import React, { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useCustomEvent } from '@beef/shop-common';
import { DeviceModal } from '@beef/smart-kit';
import PropTypes from 'prop-types';

import { COOKIES_NAMES } from 'constants/cookies';
import { MODAL_TYPE } from 'constants/modal';
import { withModal } from 'hocs/withModal';
import { clickPlace } from 'pushEvent/constants';
import { cookiesDataService } from 'services/cookiesDataService';
import { toggleCompareProduct } from 'store/common/compare/actions';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { submitOutOfStockForm } from 'store/ProductCatalog/outofstock/actions';
import { onProductDetailsReviewsClick } from 'store/ProductDetails/common/actions';
import {
  addDeviceToBasketThunk,
  fetchProductDeviceDetailsData,
  setProductDeviceDetailsIsCmpData,
} from 'store/ProductDetails/detailsModal/actions';
import {
  getProductDeviceDetailsData,
  getProductDeviceDetailsIsError,
  getProductDeviceDetailsIsFetching,
  getProductDeviceDetailsIsPurchaseLoading,
} from 'store/ProductDetails/detailsModal/selectors';
import { isProductInBasketSelector } from 'store/ProductDetails/selectors';
import { devicePreviewPurchaseButtonDataHelper } from 'utils/devicePreviewPurchaseButtonDataHelpers';

const getsubscribeData = (device, onSubmit, size) => ({
  isLoading: false,
  isSubscribed: false,
  onClick: (email, name) => {
    onSubmit({
      article: device?.article,
      email,
      id: device.id,
      name,
    });
  },
  size,
  title: device?.isSended ? 'Отправить повторно' : 'Отправить',
  variant: 'main',
});

const DetailsModal = ({ onHideAllModal }) => {
  const dispatch = useDispatch();
  const { publishDOM } = useCustomEvent();

  const { data, isError, isFeatching, isLoading, isMobile } = useSelector(
    (state) => ({
      data: getProductDeviceDetailsData(state),
      isError: getProductDeviceDetailsIsError(state),
      isFeatching: getProductDeviceDetailsIsFetching(state),
      isLoading: getProductDeviceDetailsIsPurchaseLoading(state),
      isMobile: isScreenBelow800(state),
    }),
    shallowEqual,
  );

  const isInBasketItem = useSelector(isProductInBasketSelector);

  const size = isMobile ? 's' : 'l';

  const onClick = useCallback(() => dispatch(addDeviceToBasketThunk()), [dispatch]);

  const submitOutOfStock = useCallback(
    (submitData) => {
      dispatch(submitOutOfStockForm(submitData));
      onHideAllModal();
    },
    [dispatch],
  );

  const onFetchDeviceDetails = useCallback(
    (deviceSlug) => {
      dispatch(fetchProductDeviceDetailsData(deviceSlug));
    },
    [dispatch],
  );

  const setIsFavorite = useCallback(() => {
    const favoriteDeviceList = cookiesDataService.setActualData(
      COOKIES_NAMES.FAVORITE_DEVICES,
      data.id,
    );
    publishDOM(COOKIES_NAMES.FAVORITE_DEVICES, favoriteDeviceList);
  }, [dispatch, data]);

  const onCmpClick = useCallback(() => {
    dispatch(toggleCompareProduct({ productId: data.id }));
    dispatch(setProductDeviceDetailsIsCmpData());
  }, [dispatch, data]);

  const onReviewsClick = useCallback(() => {
    dispatch(onProductDetailsReviewsClick(clickPlace.POPUP));
  }, [dispatch]);

  const purchaseButtonData = devicePreviewPurchaseButtonDataHelper({
    isInBasket: isInBasketItem,
    isPreorder: isInBasketItem ? false : data?.isPreorder,
  });

  const purchaseData = {
    ...purchaseButtonData,
    isLoading,
    onClick,
  };

  useEffect(() => {
    if (isError) {
      dispatch(onHideAllModal());
    }
  }, [isError]);

  const dataWithCmp = {
    ...data,
    cmpTooltipMsg: 'Добавить в сравнение',
    cmpTooltipMsgPos: 'bottom',
    isInCmp: data?.isCmp,
    onCmpClick,
    reviews: {
      ...data?.reviews,
      onClick: onReviewsClick,
    },
  };

  const subscribeData = getsubscribeData(data, submitOutOfStock, size);

  return (
    <DeviceModal
      data={dataWithCmp}
      isFavoriteSelected={data?.isFavorite}
      isLoading={isFeatching}
      isOpen
      onChange={onFetchDeviceDetails}
      onChangeColor={onFetchDeviceDetails}
      onClose={onHideAllModal}
      purchaseData={purchaseData}
      setFavorite={setIsFavorite}
      size={size}
      subscribeData={subscribeData}
      type={data?.contentType}
    />
  );
};

DetailsModal.propTypes = {
  onHideAllModal: PropTypes.func,
};

export default withModal(MODAL_TYPE.DETAILS_DEVICE)(DetailsModal);
